import React from 'react';

const Blogs = () => {
    return (
      <div>
        <div className="mockup-window border bg-base-300 py-12 my-12">
<div className="bg-gray-900 text-white p-8">
      <h1 className="text-3xl font-bold mb-4">How to Install Node.js and Create a Vite React Project</h1>
      <p className="text-gray-400">
        In this blog post, we'll walk through the steps to install Node.js, set up a new Vite React project, and enhance it with Tailwind CSS for beautiful styling. Whether you're a beginner or an experienced developer, this guide will help you get started quickly.
      </p>
      <h2 className="text-xl font-semibold mt-6">1. Installing Node.js</h2>
      <p className="text-gray-400">
        Node.js is a JavaScript runtime that allows you to execute JavaScript code outside of a web browser. It's essential for building modern web applications. Let's install Node.js:
      </p>
      {/* Add more content here */}
      <h2 className="text-xl font-semibold mt-6">2. Creating a Vite React Project</h2>
      <p className="text-gray-400">
        Vite is a fast build tool for modern web projects. It provides an excellent development experience and optimized production builds. Let's create a new Vite React project:
      </p>
      {/* Add more content here */}
      <h2 className="text-xl font-semibold mt-6">3. Enhancing with Tailwind CSS</h2>
      <p className="text-gray-400">
        Now that you have your Vite React project set up, let's add Tailwind CSS for styling:
      </p>
      {/* Add more content here */}
      <p className="text-gray-400 mt-6">
        You've successfully installed Node.js, created a Vite React project, and added Tailwind CSS for styling. Now you're ready to build beautiful React webpages with ease! Happy coding! 🚀🎨
      </p>
    </div>
        </div>
      </div>
    );
};

export default Blogs;